import React, { useEffect, useRef, useState } from "react";
import styles from "./NewProduct.module.sass";
import Modal from "../../components/Modal";
import Schedule from "../../components/Schedule";
import NameAndDescription from "./NameAndDescription";
import ImagesAndCTA from "./ImagesAndCTA";
import cn from "classnames";
import Panel from "./Panel";
import { UseDisclosure } from "../../hooks/use-disclosure";
import CreateTemplate from "./CreateTemplate";
import { useParams } from "react-router";
import Loader from "../../components/Loader";
import { UseApi } from "../../hooks/use-api";
import {
	CreateCollection,
	CreateNftTemplateBulk,
	GetCollection,
	UpdateCollection,
	UpdateNftTemplateBulk,
} from "../../Services/lib/nft";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import { CompareMany } from "../../Services/assets/compare-many";
import TemplateModal from "./TemplateModal";
import TemplateCard from "./TemplateCard";
import validateTemplate from "./validateTemplate";
import Card from "../../components/Card";
// import CategoryAndAttibutes from "./CategoryAndAttibutes";
// import ProductFiles from "./ProductFiles";
// import Discussion from "./Discussion";

const optionsPurchase = ["SINGLE_EDITION", "LIMITED_EDITION", "OPEN_EDITION"];

export const templateDummy = {
	name: "",
	description: "",
	price: "",
	type: optionsPurchase[0],
	totalNFTs: "",
	image: "",
	startDate: "",
	endDate: "",
};

const NewProduct = () => {
	let { id } = useParams();
	const isEdit = id !== undefined;
	const ref = useRef();

	const [initialVal_, setInitialVal_] = useState();
	const [activeKey, setActiveKey] = useState();
	const [marked, setMarked] = useState([]);

	const [visiblePreview, setVisiblePreview] = useState(false);
	const { isOpen, onOpen, onClose } = UseDisclosure();
	const {
		isOpen: openTemplate,
		onOpen: onOpenTemplate,
		onClose: onCloseTemplate,
	} = UseDisclosure();
	const [{ data }, fetch] = UseApi({
		service: GetCollection,
	});

	const [startDate, setStartDate] = useState(new Date());

	const [isLoading, setLoading] = useState(false);

	const [{}, uploadCollection] = UseApi({
		service: CreateCollection,
	});

	const [{}, updateCollection] = UseApi({
		service: UpdateCollection,
	});

	const [{}, upload] = UseApi({
		service: CreateNftTemplateBulk,
	});

	const [{}, update] = UseApi({
		service: UpdateNftTemplateBulk,
	});

	const Update = async ({ isDraft }) => {
		const isDeletedTemplate = Object.keys(reqBody.nftTemplates);
		let removedNFTids = Object.keys(initialVal.current.nftTemplates).filter(
			(x) => !isDeletedTemplate.includes(x)
		);
		let tmp = CompareMany(initialVal.current, reqBody);
		let res = [];
		let HasBeen = { ...reqBody.nftTemplates };
		if (tmp || removedNFTids.length > 0) {
			if (!tmp) {
				tmp = {};
			}
			try {
				setLoading(true);
				if (tmp.nftTemplates) {
					let templates = Object.keys(tmp.nftTemplates);
					templates = templates.map((e) => {
						const img = tmp.nftTemplates[e].image;
						const _id = e.length === 24 ? e : undefined;
						if (img && typeof img !== "string") {
							return {
								...tmp.nftTemplates[e],
								_id,
								image: img.core_image_url,
								image_list: img.image_list,
							};
						} else {
							return {
								...tmp.nftTemplates[e],
								_id,
							};
						}
					});
					res = await update(templates);
				}

				if (isDraft) {
					delete tmp.startDate;
				}
				res.forEach((e) => {
					HasBeen[e] = e;
				});
				tmp.nftTemplates = Object.keys(HasBeen).filter((x) => x.length === 24);
				if (tmp.image) {
					const tmpImg = tmp.image;
					if (typeof tmpImg !== "string") {
						tmp.image = tmpImg.core_image_url;
						tmp.image_list = tmpImg.image_list;
					}
				}
				const res_ = await updateCollection({ ...tmp, _id: id });
				if (res_) {
					ToastEmitter({
						type: "success",
						msg: isDraft
							? "Your draft saved"
							: "Your collecton successfully published",
					});
					fetch(id);
					onClose();
				}
				setLoading(false);
			} catch (error) {
				console.log(error);
				setLoading(false);
			}
		} else {
			ToastEmitter({
				type: "info",
				msg: "You have not change anything!",
			});
		}
	};

	//submit
	const Submit = async ({ isDraft = false }) => {
		if (isEdit) {
			Update({ isDraft });
			return;
		}
		try {
			setLoading(true);
			const tmp = { ...reqBody };
			let templates = Object.values(tmp.nftTemplates);
			console.log(templates);
			templates = templates.map((e) => {
				const img = e.image;
				return {
					...e,
					image: img.core_image_url,
					image_list: img.image_list,
				};
			});
			const res = await upload(templates);
			if (res) {
				if (isDraft) {
					delete tmp.startDate;
				}
				tmp.nftTemplates = res;
				const tmpImg = tmp.image;
				tmp.image = tmpImg.core_image_url;
				tmp.image_list = tmpImg.image_list;
				const res_ = await uploadCollection(tmp);
				if (res_) {
					ToastEmitter({
						type: "success",
						msg: isDraft
							? "Your draft saved"
							: "Your collecton successfully published",
					});
					setReqBody({
						name: "",
						description: "",
						image: "",
						startDate: "",
						nftTemplates: {},
					});
					ref.current.reset();
					onClose();
				}
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	};
	//submit end

	const [reqBody, setReqBody] = useState(
		isEdit
			? null
			: {
					name: "",
					description: "",
					image: "",
					startDate: "",
					nftTemplates: {},
			  }
	);

	const initialVal = useRef();

	useEffect(() => {
		if (reqBody)
			setReqBody((p) => {
				return {
					...p,
					startDate,
				};
			});
	}, [startDate]);

	useEffect(() => {
		if (isEdit) {
			fetch(id);
		} else {
			setReqBody({
				name: "",
				description: "",
				image: "",
				startDate: "",
				nftTemplates: {},
			});
		}
	}, [isEdit]);

	useEffect(() => {
		if (data) {
			const { name, description, image, nftTemplates: tmp } = data;
			const tmp_ = {};
			tmp.forEach((e_) => {
				const {
					name,
					description,
					price,
					type,
					totalNFTs,
					image,
					startDate,
					endDate,
				} = e_;
				tmp_[e_._id] = {
					name,
					description,
					price,
					type,
					totalNFTs,
					image,
					startDate,
					endDate,
				};
			});
			setReqBody({
				name,
				description,
				image,
				startDate,
				nftTemplates: tmp_,
			});
			initialVal.current = {
				name,
				description,
				image,
				startDate,
				nftTemplates: tmp_,
			};
		} else if (isEdit) {
			setReqBody(null);
			ref?.current?.reset();
		}
	}, [data]);

	const removeTemplate = (key) => {
		let tmp = { ...reqBody.nftTemplates };
		delete tmp[key];
		setReqBody((p) => {
			return {
				...p,
				nftTemplates: tmp,
			};
		});
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const res = validateTemplate(reqBody.nftTemplates);
		if (res === "empty") {
			ToastEmitter({
				type: "info",
				msg: "Product cannot be empty to publish",
			});
		} else if (res.length !== 0) {
			setMarked(res);
			ToastEmitter({
				type: "info",
				msg: "Some product has missing fields",
			});
		} else {
			onOpen();
		}
	};

	const editOpen = (e) => {
		setMarked([]);
		setActiveKey(e);
		setInitialVal_(reqBody.nftTemplates[e]);
		onOpenTemplate();
	};

	const TemplateModalOnClose = () => {
		setActiveKey();
		onCloseTemplate();
		setInitialVal_();
	};

	return reqBody ? (
		<>
			<form ref={ref} onSubmit={onSubmit}>
				<div className={styles.row}>
					<div className={styles.col}>
						<NameAndDescription
							setReqBody={setReqBody}
							reqBody={reqBody}
							className={styles.card}
						/>
						<ImagesAndCTA
							className={styles.card}
							reqBody={reqBody}
							setReqBody={setReqBody}
						/>
						{/* <HTMlEditroSection cName={styles.card} /> */}
						<Card
							className={styles.card}
							title="Products"
							classTitle="title-green"
						>
							<div className={styles.cardWrap}>
								{Object.keys(reqBody.nftTemplates).map((e, i) => {
									return (
										<TemplateCard
											marked={marked}
											key={e}
											_key={e}
											removeTemplate={() => {
												removeTemplate(e);
											}}
											editOpen={() => {
												editOpen(e);
											}}
											item={reqBody.nftTemplates[e]}
										/>
									);
								})}
							</div>
						</Card>

						<div className={styles.buttonEnd}>
							<button
								type="button"
								className={cn("button button-small", styles.button)}
								onClick={() => {
									onOpenTemplate();
									setInitialVal_(templateDummy);
								}}
							>
								Create product
							</button>
						</div>
					</div>
					{/* <div className={styles.col}>
						<Preview
							visible={visiblePreview}
							onClose={() => setVisiblePreview(false)}
						/>
					</div> */}
				</div>
				<Panel
					setVisiblePreview={setVisiblePreview}
					reqBody={reqBody}
					Submit={Submit}
					isLoading={isLoading}
				/>
			</form>

			<Modal visible={isOpen} onClose={onClose}>
				<Schedule
					isLoading={isLoading}
					action="Publish"
					title="Publish drop"
					startDate={startDate}
					setStartDate={setStartDate}
					onClick={Submit}
				/>
			</Modal>
			<TemplateModal visible={openTemplate} onClose={TemplateModalOnClose}>
				{initialVal_ && (
					<CreateTemplate
						TemplateModalOnClose={TemplateModalOnClose}
						setReqBody={setReqBody}
						initialVal={initialVal_}
						className={styles.card}
						removeTemplate={removeTemplate}
						_key={activeKey}
					/>
				)}
			</TemplateModal>
		</>
	) : (
		<div className={styles.wrap}>
			<Loader className={styles.loader} />
		</div>
	);
};

export default NewProduct;
